import {
  SET_SELECTED_FOLDER_ID,
  SET_ALL_SELECTION_FOLDERS,
  LOADING_FOLDERS,
} from '../../actions/types';

const initialState = {
  selectedFolderId: null,
  selectionFolders: [],
  loadingFolders: false,
};

/**
 * Function that takes an action and the previous state of the application and returns the new state
 * @param {object} state - contain initial and final state of data
 * @param {object} action - return the action object
 * @returns {object} updated state
 */
const folderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_SELECTION_FOLDERS:
      return {
        ...state,
        selectionFolders: action.payload,
      };
    case SET_SELECTED_FOLDER_ID:
      return {
        ...state,
        selectedFolderId: action.payload,
      };
    case LOADING_FOLDERS:
      return {
        ...state,
        loadingFolders: action.payload,
      };
    default:
      return state;
  }
};

export default folderReducer;
